export const device = {
    movile: ` (max-width:767px)`,
    tablet: `(min-width: 768px)  and  (max-width:1023px)`,
    desktop:`(min-width: 1024px)  `,
   
  };